import axios from 'axios';

export const apiMixin = {
    methods: {
        async getSystemSettings() {
            try {
                const response = await axios.post('/api/system-settings');
                return response.data;
            } catch (error) {
                console.error('Error fetching system settings:', error);
            }
        },
        async getUserProfile() {
            try {
                const response = await axios.post('/api/user');
                return response.data;
            } catch (error) {
                //console.error('Error fetching user profile:', error);
            }
        },
        async getBookedSchedules() {
            try {
                const response = await axios.post('/api/handyman/booked-schedules');
                return response.data;
            } catch (error) {
                console.error('Error fetching booked schedule:', error);
            }
        },
        async getAvailableSchedules(params) {
            try {
                const response = await axios.post('/api/handyman/available-schedules', params);
                return response.data;
            } catch (error) {
                console.error('Error fetching available schedule:', error);
            }
        }
    }
}

